export default __webpack_public_path__ + "0b3c4744999140d92b64f8ee8f75db9e.png";